import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'

@Injectable()
export class PaymentPurposesService {
  constructor(private http: HttpClient) {}

  public fetchPaymentPurposes(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/paymentPurpose/list`
    return this.http.post(url, params)
  }
  public fetchPaymentPurpose(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/paymentPurpose/${id}`
    return this.http.get(url, {})
  }

  public deletePaymentPurpose(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/paymentPurpose/${id}`
    return this.http.delete(url)
  }

  public createPaymentPurpose(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/paymentPurpose`
    return this.http.post(url, params)
  }

  public updatePaymentPurpose(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/paymentPurpose/${id}`
    return this.http.put(url, params)
  }
}
